import { render, staticRenderFns } from "./BookingUploadFiles.vue?vue&type=template&id=52af807f"
import script from "./BookingUploadFiles.vue?vue&type=script&lang=js"
export * from "./BookingUploadFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports